import './index.scss';
import isEmpty from 'lodash/isEmpty';
import { SubmissionsListItem } from './SubmissionsListItem';
import { translate } from '@utils';
import { MgState, SubmissionEntityInterface } from '@types';
import { shallowEqual, useSelector } from 'react-redux';
import { Paths } from '@constants/paths';
import { currentUserSelector } from '@selectors/user';

const SubmissionsList = () => {
  const submissions = useSelector<MgState, SubmissionEntityInterface[]>(
    ({ submission }) => submission.submissions,
    shallowEqual
  );
  const currentUser = useSelector(currentUserSelector);
  return (
    <div className="template-list-wrapper">
      <div className="template-list" data-testid="template-list">
        {!isEmpty(submissions) ? (
          submissions.map((item) => {
            const path = `${Paths.LETTERS}/${item.id}`;
            return (
              <SubmissionsListItem
                key={item.id}
                path={path}
                item={item}
                currentUserId={currentUser.id}
              />
            );
          })
        ) : (
          <div className="template-list__empty">{translate('no_templates')}</div>
        )}
      </div>
    </div>
  );
};

export { SubmissionsList };
